{
  "recommendationAccepted": null,
  "numberOfDocumentsRequested": 0,
  "setCompletionDateForEmail": "",
  "opportunityOwnerTextForEmail": "John Smith",
  "ownerEmailAddress": "john.smith@mojomortgages.com",
  "mipIssuedToCustomer": false,
  "amount": null,
  "stageName": "Online",
  "opportunityRecordType1": "RemortgageOpportunity",
  "currentExperiments": "split-ff-next-steps-variant-v4"
}
